<!--#region: campaign view accordions -->
<div>
  <p-accordion
    [multiple]="false"
    class="saas-ui saas-ui-size-default"
    styleClass="overflow-visible"
    [activeIndex]="activeAccordionIndex()"
    (activeIndexChange)="handleActiveIndexChange($any($event))">
    @for (
      campaignDimensionInfo of accordions();
      let index = $index;
      track campaignDimensionInfo.dimension
    ) {
      <p-accordionTab [disabled]="requestInProgress() || loading()">
        <ng-template pTemplate="header">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-2">
              <!--#region: accordion logo-->
              @if (
                groupByDimension() ===
                campaignAccordionService.dataSourceDimension
              ) {
                <img
                  class="data-source-icon"
                  src="/assets/images/integrations/{{
                    $any(campaignDimensionInfo.dimensionLogoStr) | lowercase
                  }}-logo.svg"
                  (error)="
                    campaignAccordionService.handleImageError(
                      $event,
                      campaignDimensionInfo
                    )
                  "
                  alt="I" />
              }
              <!--#endregion -->

              <!--#region: accordion title-->
              <span class="sh2">{{ campaignDimensionInfo.dimension }}</span>
              <!--#endregion -->

              <!--#region: accordion count-->
              <p
                class="bg-gray-200 text-gray-800 b2 rounded-full px-3 mb-0"
                [pTooltip]="
                  !!campaignDimensionInfo.isFilterApplied
                    ? 'Filters applied'
                    : ''
                "
                tooltipPosition="top"
                tooltipStyleClass="saas-tooltip"
                [ngClass]="{
                  'accordion-count-filtered':
                    !!campaignDimensionInfo.isFilterApplied,
                }">
                {{ campaignDimensionInfo.count }}
              </p>
              <!--#endregion -->

              <!--#region: accordion geo test-->
              @if (
                geoTestStatusByDimension()?.[campaignDimensionInfo.dimension]
              ) {
                <div class="flex items-center gap-1">
                  <span
                    class="flex material-symbols-outlined text-blue-600 text-base font-medium lh-1"
                    pTooltip="Campaigns in this group may<br />affect an ongoing geo test."
                    [escape]="false"
                    tooltipPosition="top"
                    tooltipStyleClass="saas-tooltip"
                    >info</span
                  >
                  <p class="text-gray-1000 b1 mb-0">Geo Test in Progress</p>
                </div>
              }
              <!--#endregion -->
            </div>

            <!--#region: spend total-->
            @if (activeTaxonomyTab() === "unmapped") {
              <div class="flex items-center gap-2">
                @if (viewFor() === "ai") {
                  <div
                    class="flex items-center"
                    pTooltip="The suggested AI campaign mappings<br /> have a {{
                      campaignDimensionInfo.confidenceScore
                    }}% confidence score."
                    [escape]="false"
                    tooltipPosition="top"
                    tooltipStyleClass="saas-tooltip">
                    <img
                      alt="AI Sparkles"
                      src="assets/images/sparkles.svg"
                      width="16px"
                      height="16px" />
                    <span class="ms-1 b1 text-gray-1000"
                      >{{ campaignDimensionInfo.confidenceScore }}%
                      confidence</span
                    >
                  </div>
                  <div class="h-8">
                    <div class="m-divider vertical"></div>
                  </div>
                }
                <div class="text-gray-1000 b1">
                  <p class="mb-0">
                    Total Spend:
                    <span class="b2">
                      {{
                        campaignDimensionInfo.spend || 0
                          | customCurrency: "1.0-0"
                      }}
                    </span>
                  </p>
                </div>
              </div>
            }
            <!--#endregion -->
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="flex flex-col w-full min-h-[14rem] overflow-visible">
            <div
              class="flex flex-col h-[4.5rem] w-full justify-between gap-2 flex-nowrap w-full flex-1 overflow-x-auto">
              <!--#region: campaigns table -->
              @if (tableTemplate()) {
                <ng-container
                  *ngTemplateOutlet="
                    tableTemplate()!;
                    context: {
                      $implicit: campaignDimensionInfo.dimension,
                      index: index,
                    }
                  "></ng-container>
              } @else {
                <ng-content select="[content=table]"></ng-content>
              }
              <!--#endregion -->
            </div>
            <div>
              <!--#region: tactic selector -->
              @if (dimensionUpdateTemplate()) {
                <ng-container
                  *ngTemplateOutlet="
                    dimensionUpdateTemplate()!;
                    context: {
                      $implicit: campaignDimensionInfo.dimension,
                      index: index,
                    }
                  "></ng-container>
              } @else {
                <ng-content select="[content=dimension-update]"></ng-content>
              }
              <!--#endregion -->
            </div>
          </div>
        </ng-template>
      </p-accordionTab>
    }
  </p-accordion>
</div>
<!--#endregion -->
